import { useEffect } from 'react'
import { ConfigProvider } from 'antd'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import LandingPage from './pages/LandingPage'
import { useLocale } from './hooks/useLocale'
import './styles/global.css'

export default function App() {
  const { locale, setLocale, copy } = useLocale()

  useEffect(() => {
    document.documentElement.lang = locale
    document.title = copy.seo.title
    const description = document.querySelector('meta[name="description"]')
    description?.setAttribute('content', copy.seo.description)
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', copy.seo.title)
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', copy.seo.description)
  }, [locale, copy.seo])

  const RECAPTCHA_SITE_KEY = '6LdD9astAAAAAGLmZQ_uPizVuuyeQOGL7bUGqUNm'

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <ConfigProvider theme={{ token: { colorPrimary: '#bb9231', colorText: '#10233b', borderRadius: 2, fontFamily: 'DM Sans, Arial, sans-serif' } }}>
        <LandingPage locale={locale} setLocale={setLocale} copy={copy} />
      </ConfigProvider>
    </GoogleReCaptchaProvider>
  )
}
